<template>
    <div class="img-carousel-container">
        <img src="../../assets/arrow-left.svg" alt="" @click="imgLeft">
        <ul class="img-ul-carousel">
            <li v-for="(item,index) in imgList" :key="index" class="img-li-carousel" :style="imgStyle"
                @click="changeImg(item, index)">
                <img :class="index === imgActiveIndex ? 'img_activeBorder' : ''" :src="item">
            </li>
        </ul>
        <img src="../../assets/arrow-right.svg" alt="" @click="imgRight">
    </div>
</template>

<script>
    export default {
        props: {
            imgList: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                imgActiveIndex: 0, // 当前移动图片的索引值
                imgDistance: 0, // 移动的距离
                allDistance: 0, // 总移动距离
            }
        },
        computed: {
            imgStyle() {
                return {
                    transform: `translateX(${this.imgDistance}px)` // 计算移动的距离(x,y,z)
                }
            }
        },
        methods: {
            changeImg(item, index) {
                this.imgActiveIndex = index
                this.$emit('setBigImg',item)
            },
            imgLeft() {
                if (this.imgActiveIndex > 0) {
                    this.imgActiveIndex--  // 索引值-1
                    this.imgList.forEach((item, index) => { // 循环小图,通过判断索引值赋值给大图
                        if (this.imgActiveIndex === index) {
                            this.$emit('setBigImg',item)
                        }
                    })
                }
                if (this.imgActiveIndex >= 4) {
                    this.allDistance = -81 * (this.imgActiveIndex - 4)
                    this.imgDistance += 111 // 每次向左移动的距离
                }else if(this.imgActiveIndex === 0) {
                    this.imgDistance = 0
                }
            },
            imgRight() {
                if (this.imgActiveIndex < this.imgList.length - 1) {
                    this.imgActiveIndex++
                    this.imgList.forEach((item, index) => {
                        if (this.imgActiveIndex === index) {
                            this.$emit('setBigImg',item)
                        }
                    })
                    if (this.imgActiveIndex+1 >= 5) {
                        this.allDistance = -81 * (this.imgActiveIndex - 4)
                        this.imgDistance -= 111 // 每次向右移动的距离
                    }
                } else if (this.imgActiveIndex === this.imgList.length - 1) { // 到达最后一张图片，再点击跳转回第一张
                    this.imgActiveIndex = 0;
                    this.$emit('setBigImg',this.imgList[0])
                    this.imgDistance = 0
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/styles/var.less";

    .img-carousel-container {
        width: 100%;
        height: 100%;
        display: flex;
    }

    .img-ul-carousel {
        position: relative;
        width: 430px;
        height: 100%;
        white-space: nowrap;
        overflow: hidden;
    }

    .img-li-carousel {
        width: 81px;
        height: 81px;
        display: inline-block;
        box-sizing: border-box;
        border-radius: 5px;
        overflow: hidden;
        cursor: pointer;
        transition:0.5s;
    }
    .img-li-carousel:not(:first-child) {
        margin-left: 29px;
    }
    .img-li-carousel img {
        width: 81px;
        height: 81px;
    }

    .img_activeBorder {
        border: 3px solid @primary;
        box-sizing: border-box;
    }
</style>